<template>
  <div id="app">
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {
    $route (to) {
      this.$nextTick(() => {
        if (document.querySelector('.el-main')) {
          document.querySelector('.el-main').scrollTop = 0;
        }
      })
    }
  }
};
</script>
<style lang="scss">
@import "./styles/reset";

[v-cloak] {
  display: none;
}

#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* 全局设置 element ui dialog水平垂直居中 */
.el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}
.button-small {
  width: 98px;
  height: 32px;
  line-height: 32px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
}
</style>
